import script from "./CategorySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./CategorySelector.vue?vue&type=script&setup=true&lang=js"

import "./CategorySelector.vue?vue&type=style&index=0&id=22b35a99&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b35a99"]])

export default __exports__